import { tap, map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SocketIoService } from './socket.io-service';
import { Pagination } from '@shared/models/pagination.model';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class WSSEventSettingDataService {

  pagination: Pagination
  messages$ = new Subject<any[]>();
  wssStatusChanged$ = new Subject<{ event_name: string, status: number }>();
  unsubscribeWssEvents: (() => void) | null = null;
  private isBrowser: boolean;

  constructor(private http: HttpClient, private socketIoService: SocketIoService, @Inject(PLATFORM_ID) platformId: Object) {
     this.isBrowser = isPlatformBrowser(platformId);
     if (this.isBrowser) {
       this.listenToWssEventSettingUpdates();
     }
  }

  getWSSEventStatus(eventName: string): Observable<boolean> {
    return this.http.get<ApiResponse>(`/wsseventsettings/statuscheck?event_name=${eventName}`).pipe(
      map(res => res.data.status === 1)
    );
  }

  getCachedWssStatus(eventName: string): Observable<boolean> {
    const cacheRaw = sessionStorage.getItem('wss_event_statuses');
    const cache = cacheRaw ? JSON.parse(cacheRaw) : {};

    if (cache[eventName] !== undefined) {
      return new Observable((observer) => {
        observer.next(cache[eventName] === 1);
        observer.complete();
      });
    }

    return this.getWSSEventStatus(eventName).pipe(
      tap((isActive) => {
        cache[eventName] = isActive ? 1 : 0;
        sessionStorage.setItem('wss_event_statuses', JSON.stringify(cache));
      })
    );
  }

  listenToWssEventSettingUpdates() {
    this.unsubscribeWssEvents = this.socketIoService.channel('wss-events').listen('WssEventSettingEvent', (data: { event_name: string, status: number }) => {
      const raw = sessionStorage.getItem('wss_event_statuses');
      const statuses = raw ? JSON.parse(raw) : {};
      statuses[data.event_name] = data.status;
      sessionStorage.setItem('wss_event_statuses', JSON.stringify(statuses));

      this.wssStatusChanged$.next({ event_name: data.event_name, status: data.status });
    });
  }

  disconnectSocket() {
    if (this.unsubscribeWssEvents) {
      this.unsubscribeWssEvents();
    }
    this.socketIoService.leave('wss-events');
    this.unsubscribeWssEvents = null;
  }
}
